import styled from "@emotion/styled";
const StyledWearablePreview = styled("iframe")({
    background: "transparent",
    border: 0,
    width: "100%",
    height: "100%",
});
export { StyledWearablePreview };
//# sourceMappingURL=WearablePreview.styled.js.map